module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container main-app"
  }, [(!_vm.$mobile) ? _c('div', {
    staticClass: "main-bg-image",
    style: ({
      backgroundImage: 'url(' + _vm.thumbnail + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-bg-cover"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mobile && _vm.orientation === 'landscape' || !_vm.$mobile),
      expression: "$mobile && orientation === 'landscape' || !$mobile"
    }],
    staticClass: "desktop-view"
  }, [_c('transition', {
    attrs: {
      "name": "popup",
      "mode": "out-in"
    }
  }, [(_vm.$store.state.carousel.show) ? _c('Carousel') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "vignette"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mobile && _vm.orientation === 'portrait'),
      expression: "$mobile && orientation === 'portrait'"
    }],
    staticClass: "mobile-view"
  }, [_c('div', {
    staticClass: "mobile-warning"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-921a9a6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 123
// module chunks = 1